import { tagAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, } from '@chakra-ui/styled-system';
import { ThemeColorVariable, ThemeFontSizeVariable, ThemeFontVariable, ThemeIconSizeVariable, ThemeRadiusVariable, ThemeSpaceVariable, } from '../../theme-types';
const TagVariants = [
    'Primary',
    'Secondary',
    'Success',
    'Error',
    'Info',
    'Neutral',
    'Warning',
];
// Selectors for our custom Tag component parts, to be able to style them within theme
const dotSelector = '.tag-dot';
const iconSelector = '.tag-icon';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const SolidVariants = TagVariants.reduce((solidVariants, key) => {
    const variant = solidVariants;
    const variantKey = `${key.toLowerCase()}Solid`;
    const backgroundColorKey = key;
    const textColorKey = `On${key}`;
    variant[variantKey] = definePartsStyle({
        container: {
            backgroundColor: ThemeColorVariable[backgroundColorKey],
            color: ThemeColorVariable[textColorKey],
            [dotSelector]: {
                backgroundColor: ThemeColorVariable[textColorKey],
            },
        },
    });
    return variant;
}, {});
const SubtleVariants = TagVariants.reduce((subtleVariants, key) => {
    const variant = subtleVariants;
    const variantKey = `${key.toLowerCase()}`;
    const dotColor = key;
    const backgroundColor = `${key}Container`;
    const textColor = `On${key}Container`;
    variant[variantKey] = definePartsStyle({
        container: {
            color: ThemeColorVariable[textColor],
            backgroundColor: ThemeColorVariable[backgroundColor],
            [dotSelector]: {
                backgroundColor: ThemeColorVariable[dotColor],
            },
        },
    });
    return variant;
}, {});
const baseStyle = definePartsStyle({
    container: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'flex-start',
        width: 'fit-content',
        gap: ThemeSpaceVariable.XSmall,
        px: ThemeSpaceVariable.Small,
        bg: ThemeColorVariable.NeutralContainer,
        color: ThemeColorVariable.OnNeutralContainer,
        borderRadius: ThemeRadiusVariable.Small,
    },
    label: {
        alignItems: 'center',
        fontWeight: '500',
        lineHeight: '150%',
        mx: ThemeSpaceVariable.XSmall,
        letterSpacing: '0.0125em',
        font: ThemeFontVariable.Body,
    },
    closeButton: {
        opacity: '0.48',
        margin: 0,
    },
});
const xs = definePartsStyle({
    container: {
        minHeight: '24px',
        [dotSelector]: {
            width: '12px',
            height: '12px',
        },
        [iconSelector]: {
            height: ThemeIconSizeVariable.Small,
            width: ThemeIconSizeVariable.Small,
        },
    },
    label: {
        fontSize: ThemeFontSizeVariable.Small,
    },
    closeButton: {
        fontSize: ThemeIconSizeVariable.Small,
    },
});
const sm = definePartsStyle({
    container: {
        minHeight: '32px',
        [dotSelector]: {
            width: '14px',
            height: '14px',
        },
        [iconSelector]: {
            height: ThemeIconSizeVariable.Medium,
            width: ThemeIconSizeVariable.Medium,
        },
    },
    label: {
        fontSize: ThemeFontSizeVariable.Medium,
    },
    closeButton: {
        fontSize: ThemeIconSizeVariable.Medium,
    },
});
const md = definePartsStyle({
    container: {
        minHeight: '40px',
        [dotSelector]: {
            width: '14px',
            height: '14px',
        },
        [iconSelector]: {
            height: ThemeIconSizeVariable.Medium,
            width: ThemeIconSizeVariable.Medium,
        },
    },
    label: {
        fontSize: ThemeFontSizeVariable.Large,
    },
    closeButton: {
        fontSize: ThemeIconSizeVariable.Medium,
    },
});
const comboboxItemVariant = definePartsStyle({
    container: {
        color: ThemeColorVariable.OnSurface,
        backgroundColor: ThemeColorVariable.SurfaceDisabled,
        [dotSelector]: {
            backgroundColor: ThemeColorVariable.OnSurface,
        },
    },
});
const sizes = {
    xs,
    sm,
    md,
};
export const tagConfig = defineMultiStyleConfig({
    baseStyle,
    sizes,
    variants: {
        ...SolidVariants,
        ...SubtleVariants,
        comboboxItem: comboboxItemVariant,
    },
});
//# sourceMappingURL=tag-theme.js.map